module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"area":"Luogo","duration":"Durata","months":"mesi"},"en":{"area":"Location","duration":"Duration","months":"months"}}')
  delete Component.options._Ctor
}
